import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../shared/hooks';
import { adminLogin, adminLogout, clearAdminError } from '../../store/slices/adminAuthSlice';

export const useAdminAuth = () => {
  const dispatch = useAppDispatch();
  
  // Estados desde Redux
  const { 
    isAuthenticated, 
    adminData, 
    token, 
    loading, 
    error, 
    isInitialized 
  } = useAppSelector(state => state.adminAuth);

  // Login de administrador
  const login = useCallback(async (credentials) => {
    try {
      const result = await dispatch(adminLogin(credentials)).unwrap();
      return result;
    } catch (error) {
      // El error ya está manejado en el slice, no re-lanzarlo
      console.error('Error en login:', error);
      return null;
    }
  }, [dispatch]);

  // Logout de administrador
  const logout = useCallback(async () => {
    try {
      await dispatch(adminLogout()).unwrap();
    } catch (error) {
      // El logout siempre limpia el estado, incluso si hay error
      console.error('Error en logout:', error);
    }
  }, [dispatch]);

  // Limpiar error
  const clearError = useCallback(() => {
    dispatch(clearAdminError());
  }, [dispatch]);

  return {
    isAuthenticated,
    loading,
    error,
    adminData,
    token,
    isInitialized,
    login,
    logout,
    clearError,
  };
}; 